import { Component, OnInit , EventEmitter, HostListener} from '@angular/core';
import { ApiRequestService } from '../../../_services/api-request.service';
import { MaterializeAction } from 'angular2-materialize';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { saveAs } from 'file-saver';
import { Router } from "@angular/router";

declare var $:any;
declare var Materialize:any;

@Component({
  selector: 'app-medicolegal',
  templateUrl: './medicolegal.component.html',
  styleUrls: ['./medicolegal.component.css']
})
export class MedicolegalComponent implements OnInit {

  view_allow = false;

  html: SafeHtml;
  CT_modal = new EventEmitter<string | MaterializeAction>();
  

  modal_loading = 1;
  

  bodypartlist = ['Lumbar Spine'];

  case_list;
  keyword;
  static global_word;

  imrdetail;
  loads=1;
  bodypart = "Choose Your Option";
  
  list_causes_symptoms;
  causes_name;
  causes_loader = 0;
  list_causes_symptoms_loader = 0;

  list_symptoms;
  symptoms_loader = 0;


  symptom_name;
  phase_1_loader = 0;

  phase_1a_loader = 0;
  list_d;
  list_d_loader = 0;
  d_name;
  list_drugs; 
  drug_name;
  phase_2_loader = 0;
  treatment_data;

  clinical_summary;
  clinical_summary_loader = 0;
  summary_keys;

  dataid = 0;
  divcode;
  tags;
  tag_id;
  which_vise;
  label_chart;

  CausesArray = [];
  SymptomsArray = [];
  DiseasesArray = [];
  DrugsArray = [];

  Selections_Record;


  CausesCheckbox = [];
  SymptomsCheckbox = [];
  DiseasesCheckbox = [];
  DrugsCheckbox = [];

  casedata = 0;

  stepper = 0;

  constructor(private apirequest: ApiRequestService,private sanitizer: DomSanitizer, private router : Router) { }

  ngOnInit() {
      this.cases(); 
      setTimeout(() => {
        this.view_allow = true;
        this.md_call();  
      }, 1000); 
      // this.case_list = JSON.parse(localStorage.getItem("cases"));
      // if(this.case_list != undefined){
      //   this.load_data();
      // }    
  }

  cases(){
    // console.log(keyword);
    let input;
   
    input =  {action:"get_all_case_no",case_number:""};
    
    
    this.apirequest.case(input).subscribe(res => {
      // console.log(res.msg);
      
      if(res.status === "True") {
        localStorage.setItem("cases",JSON.stringify(res.msg));
        setTimeout(() => {
          this.case_list = JSON.parse(localStorage.getItem("cases"));
          if(this.case_list != undefined){
            this.casedata = 1;
            this.load_data();
            // console.log(this.case_list);
            
          }
        }, 3000);
      } else if(res.status === "False") {
          this.msg_view(res.msg);
      }       
    });
  }

  md_call(){
    $(document).ready(function() {
      Materialize.updateTextFields();
    });
  } 

  
 
  msg_view(msg_data) {
    $(document).ready(function() {
      Materialize.toast(msg_data.toString(), 3000, 'grey darken-4');
    });
  }

  set_disease(){
    // console.log(this.disease);
    // console.log(this.depth);
    // console.log(this.rotate);   
    
  }

  case_call(){
    // this.modal_loading = 0;
    // console.log(keyword);
    let input;
    input =  {action:"get_case_detail",case_number:this.keyword};
    console.log(input);
    
    this.apirequest.case(input).subscribe(res => {
      // console.log(res);  
      if(res.status == "True") {
        this.loads = 1;
        this.imrdetail = res.msg;
        setTimeout(() => {
          this.hover('original_btn');
        }, 1000);
      } else {
        this.loads = 1;
        this.imrdetail = undefined;
        this.msg_view(res.msg);
      }
    });
  }

  load_data(){
    let name = {};
    for (var i = 0; i < this.case_list.length; i++) {
      name[this.case_list[i]] = null;
      // console.log(name[this.drugs_name[i]]);
      
    }
    $('input.autocomplete').autocomplete({
      data: name,
      limit: 10, // The max amount of results that can be shown at once. Default: Infinity.
      onAutocomplete: function(val) {
        // Callback function when value is autcompleted.
        console.log(val);
        MedicolegalComponent.global_word = val;
        
      },
      minLength: 1, // The minimum length of the input for the autocomplete to start. Default: 1.
    });
  }

  onSearchChange(searchValue: string) {  
    // console.log(searchValue);
    MedicolegalComponent.global_word = searchValue;
  }

  onEnter() {
    this.loads = 0;
    // console.log(this.keyword);
    this.keyword = MedicolegalComponent.global_word;
    setTimeout(() => {
      // console.log(this.keyword.length);
      if(this.keyword.length === 12){
        this.case_call();
      } else {
        this.loads = 1;
        this.imrdetail = undefined;
        this.msg_view("Unable to Find Case Number");
      }
      
    }, 1000);
    
    

  }

     
  ct_view(){
    
    // this.CT_modal.emit({action: 'modal', params: ['open']});
    // $("#Case_Vise").removeClass("active");
    // $('#Body_Parts_Vise').addClass("active");
    // setTimeout(() => {
    //   this.modal_tab('Body_Parts_Vise');
    // }, 1000);
    this.router.navigate(['/user/workers']);
  }

  ct_close(){
    this.CT_modal.emit({action: 'modal', params: ['close']});
    this.list_d = undefined;
    this.list_d_loader = 0;
    this.d_name = undefined;
    this.phase_1_loader = 0;
    this.list_drugs = undefined; 
    this.drug_name = undefined;
    this.phase_2_loader = 0;
    this.treatment_data = undefined;
    this.bodypart = "Choose Your Option";
    this.which_vise = undefined;
    this.clinical_summary = undefined; 
    this.list_causes_symptoms = undefined;
    this.causes_name = undefined;
    this.causes_loader = 0;
    this.list_causes_symptoms_loader = 0;
    this.list_symptoms = undefined;
    this.symptoms_loader = 0;
    this.symptom_name = undefined;
    this.CausesArray = [];
    this.SymptomsArray = [];
    this.DiseasesArray = [];
    this.DrugsArray = [];
    this.CausesCheckbox = [];
    this.SymptomsCheckbox = [];
    this.DiseasesCheckbox = [];
    this.DrugsCheckbox = [];
    this.Selections_Record = undefined;  
  }

  phase_1(){
    this.list_causes_symptoms_loader = 1;
    let input = {
      action:"get_causes",
      bodypart:"lumbar_spine",
      disease_name:""
    }
    console.log(input);
    this.apirequest.customize_flow(input).subscribe(res => {
      console.log(res);  

      if(res.status == 'True') {        
        this.list_causes_symptoms_loader = 0;
        this.list_causes_symptoms = res.msg;
        this.stepper = 1;
      } else {
        this.stepper = 0;
        this.list_causes_symptoms_loader = 0;
        this.msg_view(res.msg);
      }
      
      
    });
    
  }

  set_causes(item,id){
    this.causes_name = item;
    console.log(this.causes_name);
    this.Checkbox_Drum('causes', item, id);
  }

  phase_1b(){
    this.SymptomsArray = [];
    this.SymptomsCheckbox = [];
    this.DiseasesArray = [];
    this.DiseasesCheckbox = [];
    this.DrugsArray = [];
    this.DrugsCheckbox = [];
    this.list_d = undefined;
    this.list_d_loader = 0;
    this.d_name = undefined;
    this.phase_1_loader = 0;
    this.list_drugs = undefined; 
    this.drug_name = undefined;
    this.phase_2_loader = 0;
    this.treatment_data = undefined;
    this.clinical_summary = undefined; 
    this.list_causes_symptoms_loader = 0;
    this.list_symptoms = undefined;
    this.symptoms_loader = 0;
    this.symptom_name = undefined;  
    this.causes_loader = 1;
    let input = {
      action:"get_symptoms_using_causes",
      bodypart:"lumbar_spine",
      causes_name:this.CausesArray
    }
    console.log(input);
    this.apirequest.customize_flow(input).subscribe(res => {
      console.log(res);  

      if(res.status == 'True') {        
        this.causes_loader = 0;
        this.list_symptoms = res.msg;
        this.stepper = 2;
        setTimeout(() => {
          $(document).ready(function(){
            $('.ratio').addClass("show");
          });
        }, 1500);
        this.Selections_Record = true;
      } else {
        this.stepper = 0;
        this.causes_loader = 0;
          this.msg_view(res.msg);
      }
      
      
    });
    
  }
  
  set_name_symptom(item,id){
    console.log(item);   
    this.symptom_name = item;
    this.Checkbox_Drum('symptoms', item, id);   
  }

  phase_1a(){
    this.list_drugs = undefined;
    this.treatment_data = undefined;
    this.clinical_summary = undefined; 
    this.d_name = undefined;
    this.list_d = undefined;
    this.DiseasesArray = [];
    this.DiseasesCheckbox = [];
    this.DrugsArray = [];
    this.DrugsCheckbox = [];
    // this.reset();
    this.symptoms_loader = 1;
    let input = {
      action:"get_disease_using_symptom",
      bodypart:"lumbar_spine",
      disease_name:"",
      causes_name:this.CausesArray,
      symptom_name: this.SymptomsArray,
      by_cause:true
    }
    console.log(input);
    this.apirequest.customize_flow(input).subscribe(res => {
      console.log(res);  

      if(res.status == 'True') {        
        this.symptoms_loader = 0;
        this.list_d = res.msg;
        this.stepper = 3;
        setTimeout(() => {
          $(document).ready(function(){
            $('.ratio').addClass("show");
          });
        }, 1500);
      } else {
        this.stepper = 0;
        this.symptoms_loader = 0;
          this.msg_view(res.msg);
      }
      
      
    });
    
  }

  set_name(item,id){
    // console.log(item);   
    this.d_name = item;
    this.Checkbox_Drum('diseases', item, id);   
  }
    
  phase_2(){
    this.DrugsArray = [];
    this.DrugsCheckbox = [];
    this.clinical_summary = undefined;
    this.dataid = 0;
    this.treatment_data=undefined;
    this.list_drugs= undefined; 
    this.phase_1_loader = 1;
    let input = {
      action:"get_drugs_ratio",
      bodypart:"lumbar_spine",
      disease_name:this.DiseasesArray,
      symptom_name: this.SymptomsArray,
      causes_name:this.CausesArray,
      by_cause:true
    }
    console.log(input);
    
    this.apirequest.customize_flow(input).subscribe(res => {
      // console.log(res);  

      if(res.status == 'True') {
        // console.log("done");
        this.stepper = 4;
        this.phase_1_loader = 0;
        this.list_drugs = res.msg;
        // console.log(this.list_drugs);
        // this.phase_3();
        
      } else {
        this.stepper = 0;
        this.phase_1_loader = 0;
          this.msg_view(res.msg);
      }
      
      
    });
  }

  set_drugname(item,id){
    // console.log("killer");
    
    console.log(item);   
    this.drug_name = item.drug_name; 
    this.Checkbox_Drum('drugs', item.drug_name, id); 
  }

  treatment_status;

  phase_3(){
    this.phase_2_loader = 1;
    let input = {
      action:"get_treatments",
      bodypart:"lumbar_spine",
      disease_name:this.DiseasesArray
    }
    console.log(input);
    this.apirequest.customize_flow(input).subscribe(res => {
      // console.log(res);  

      if(res.status == 'True') {
        // console.log("done");
        this.stepper = 5;
        this.phase_2_loader = 0;
        this.treatment_status = res.status;
        this.treatment_data = res.msg;
        // console.log(this.treatment_data);
        
      } else {
        this.treatment_status = res.status;
        this.stepper = 0;
        this.phase_2_loader = 0;
          this.msg_view(res.msg);
      }
      
      
    });
  }

  getClinicalSummary(){
    this.clinical_summary = undefined;
    this.dataid = 0;
    this.clinical_summary_loader = 1;
    let input = {
      action:"get_clinical_summary",
      bodypart:"lumbar_spine",
      symptom_name:this.SymptomsArray,
      disease_name:this.DiseasesArray,
      drug_name:this.DrugsArray,
      causes_name:this.CausesArray
    }
    console.log(input);
    this.apirequest.customize_flow(input).subscribe(res => {
      console.log(res); 
      // res.msg = {Uphold: "the mg twice a day ibuprofen mg once a day and omeprazole the",
      // Uphold2: "mg twice a day ibuprofen mg once a day and omeprazole the",
      // Upholasdd: "mg twice a day ibuprofen mg once a day and omeprazole the",
      // Upholasdd2: "mg twice a day ibuprofen mg once a day and omeprazole the",}
      this.summary_keys = Object.keys(res.msg);
      console.log(this.summary_keys);
       

      if(res.status == 'True') {        
        this.clinical_summary_loader = 0;
        if(this.summary_keys.length != 0){
          this.stepper = 6;
          this.clinical_summary = res.msg;
        } else {
          this.msg_view('Empty Response')
        }
        
      } else {
        this.stepper = 0;
        this.clinical_summary_loader = 0;
          this.msg_view(res.msg);
      }
      
      
    });
  }

  setvalue(id){
    this.dataid = this.dataid + id; 
    console.log(this.dataid);
    
  }
 
  reset(){
    this.treatment_data=undefined;
    this.list_drugs= undefined; 
    this.drug_name = undefined;
    this.phase_2_loader = 0;
    this.d_name = undefined;
    this.list_d = undefined;
    this.clinical_summary = undefined;

    this.CausesArray = [];
    this.SymptomsArray = [];
    this.DiseasesArray = [];
    this.DrugsArray = [];
    this.CausesCheckbox = [];
    this.SymptomsCheckbox = [];
    this.DiseasesCheckbox = [];
    this.DrugsCheckbox = [];  
    this.Selections_Record = undefined;
    this.symptom_name = undefined;
    this.stepper_id(1);
    this.list_symptoms = undefined;
  }

  hover(id){
    $(document).ready(function() {
      $(".imr-content button").click(function () {
          $(".imr-content button").removeClass("active");
          $(this).addClass("active");   
      });
    });

    if(id === 'target_btn'){
      this.tag_id = id;
      setTimeout(() => {
        $(document).ready(function(){
          $('ul.tabs').tabs();
        });
      }, 10);
      this.tags_call('entity_tags');
    } else {
      this.tag_id = undefined;
      this.tags = undefined;
    }

    // console.log(typeof(this.html));
    // console.log(this.html);
  }
  
  tags_call(id){
    this.tags = id;
    let input = {
      action:"get_case_detail_tagged",
      case_number:this.keyword,
      flag:id
    }
    console.log(input);
    
    this.apirequest.case(input).subscribe(res => {
      // console.log(res);  
      if(res.status == "True") {
        // this.divcode = '<div class="entities" style="line-height: 2.5; direction: ltr"><mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    maximus    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    federal services    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> sent the complete case file to an <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    expert    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    reviewer    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> the <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    expert    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    reviewer    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> has no <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    affiliation    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> with the <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    employer    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    employee providers    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> or the claims <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    administrator    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> has been in <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    active clinical practice    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> for more than five <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    years    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> and is currently <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    working    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> at least hours a <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    week    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> in <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    active practice    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> was selected based on his her <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    clinical    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> experience education background and <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    expertise    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> in the same or similar <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    specialties    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> that <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    evaluate    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> and or <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    treat    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> the <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    medical condition    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> and disputed <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    items    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    service    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> is familiar with governing <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    laws    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> and <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    regulations    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> applied the <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    mtus    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    medical    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> evidence <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    search sequence    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> and <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    mtus    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    methodology    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> for <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    evaluating    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    medical    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    evidence    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> where <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    appropriate    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> and has the following <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    credentials state    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> s of <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    licensure california    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    certification    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> s <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    specialty    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    physical medicine    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    rehabilitation    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark></div>';
        // console.log(this.divcode);
        this.divcode = res.msg;
        this.html = this.sanitizer.bypassSecurityTrustHtml(this.divcode);
      } else {
        this.divcode = '<div class="col s12 center red-text"><p>'+res.msg+'</p></div>';
        this.html = this.sanitizer.bypassSecurityTrustHtml(this.divcode);
        this.msg_view(res.msg);
      }
    });
  }
  
  modal_tab(id){
    $(document).ready(function() {
      $(".tab-btn").click(function () {
          $(".tab-btn").removeClass("active");
          $(this).addClass("active");   
      });
    });
    this.which_vise = id;
    console.log(this.which_vise);
    if(this.which_vise === 'Body_Parts_Vise'){
      setTimeout(() => {
        $(document).ready(function(){
          $('.ratio').addClass("show");
        });
      }, 1000);
    } 
    
  }

  Checkbox_Drum(type,data,id){
    console.log(data);
    console.log(id);
    let checkbox:any = document.getElementById(id);
    if(type === 'causes') {
      if(checkbox.checked == false) {
        const index = this.CausesArray.indexOf(data);
        if (index > -1) {
          this.CausesArray.splice(index, 1);
        }
        console.log(this.CausesArray);

        const index1 = this.CausesCheckbox.indexOf(id);
        if (index1 > -1) {
          this.CausesCheckbox.splice(index1, 1);
        }
        console.log(this.CausesCheckbox);
      } else if(checkbox.checked == true) {
        this.CausesArray.push(data);
        console.log(this.CausesArray);
        this.CausesCheckbox.push(id);
        console.log(this.CausesCheckbox);
      }
    } else if(type === 'symptoms') {
      if(checkbox.checked == false) {
        const index = this.SymptomsArray.indexOf(data);
        if (index > -1) {
          this.SymptomsArray.splice(index, 1);
        }
        console.log(this.SymptomsArray);
        const index1 = this.SymptomsCheckbox.indexOf(id);
        if (index1 > -1) {
          this.SymptomsCheckbox.splice(index1, 1);
        }
        console.log(this.SymptomsCheckbox);
      } else if(checkbox.checked == true) {
        this.SymptomsArray.push(data);
        console.log(this.SymptomsArray);
        this.SymptomsCheckbox.push(id);
        console.log(this.SymptomsCheckbox);
      }

    } else if(type === 'diseases') {
      if(checkbox.checked == false) {
        const index = this.DiseasesArray.indexOf(data);
        if (index > -1) {
          this.DiseasesArray.splice(index, 1);
        }
        console.log(this.DiseasesArray);
        const index1 = this.DiseasesCheckbox.indexOf(id);
        if (index1 > -1) {
          this.DiseasesCheckbox.splice(index1, 1);
        }
        console.log(this.DiseasesCheckbox);
      } else if(checkbox.checked == true) {
        this.DiseasesArray.push(data);
        console.log(this.DiseasesArray);
        this.DiseasesCheckbox.push(id);
        console.log(this.DiseasesCheckbox);
      }

    } else if(type === 'drugs') {
      if(checkbox.checked == false) {
        const index = this.DrugsArray.indexOf(data);
        if (index > -1) {
          this.DrugsArray.splice(index, 1);
        }
        console.log(this.DrugsArray);
        const index1 = this.DrugsCheckbox.indexOf(id);
        if (index1 > -1) {
          this.DrugsCheckbox.splice(index1, 1);
        }
        console.log(this.DrugsCheckbox);
      } else if(checkbox.checked == true) {
        this.DrugsArray.push(data);
        console.log(this.DrugsArray);
        this.DrugsCheckbox.push(id);
        console.log(this.DrugsCheckbox);
      }
    }
    
  }
  

  stepper_id(id){
    console.log(id);
    var checkerid:any;
    this.stepper = id;
    if(this.stepper == 2 || this.stepper == 3) {
      setTimeout(() => {
        $(document).ready(function(){
          $('.ratio').addClass("show");
        });
      }, 1500);
    }

    if(this.stepper == 1 && this.CausesCheckbox.length != 0){
      console.log(this.CausesCheckbox);      
      setTimeout(() => {
        for (let index = 0; index < this.CausesCheckbox.length; index++) {
          checkerid = document.getElementById(this.CausesCheckbox[index]);
          checkerid.checked = true;
        }  
      }, 1000);
    }
    if(this.stepper == 2 && this.SymptomsCheckbox.length != 0){
      console.log(this.SymptomsCheckbox);      
      setTimeout(() => {
        for (let index = 0; index < this.SymptomsCheckbox.length; index++) {
          checkerid = document.getElementById(this.SymptomsCheckbox[index]);
          checkerid.checked = true;
        }  
      }, 1000);
    }
    if(this.stepper == 3 && this.DiseasesCheckbox.length != 0){
      console.log(this.DiseasesCheckbox);      
      setTimeout(() => {
        for (let index = 0; index < this.DiseasesCheckbox.length; index++) {
          checkerid = document.getElementById(this.DiseasesCheckbox[index]);
          checkerid.checked = true;
        }  
      }, 1000);
    }
    if(this.stepper == 4 && this.DrugsCheckbox.length != 0){
      console.log(this.DrugsCheckbox);      
      setTimeout(() => {
        for (let index = 0; index < this.DrugsCheckbox.length; index++) {
          checkerid = document.getElementById(this.DrugsCheckbox[index]);
          checkerid.checked = true;
        }  
      }, 1000);
    }
  }

  sidebarEvent() {
    $(document).ready(function(){
      $('.custom-sidebar-container').addClass("active");
    });
  }

  onMouseLeave() {
    $('.custom-sidebar-container').on('mouseleave', function() {
      $(this).removeClass('active');
   });
  }



  download_text(){
    console.log(this.tag_id);
    
    if(this.tag_id === undefined){
      let file = new Blob(["Case Number: "+this.imrdetail.case_number+"\r\n"+"\r\n"+
      "==================================="+"\r\n"+
      "Clinical Summary : "+"\r\n"+"==================================="+"\r\n"+this.imrdetail.clinical_simmary+"\r\n"+"\r\n"+
      "IMR Final : "+"\r\n"+"==================================="+"\r\n"+this.imrdetail.how_imr_final_determ+"\r\n"+"\r\n"+
      "IMR Decision Explanation : "+"\r\n"+"==================================="+"\r\n"+this.imrdetail.imr_decision_explan+"\r\n"+"\r\n"+
      "IMR Decision Summary : "+"\r\n"+"==================================="+"\r\n"+this.imrdetail.imr_decision_summary+"\r\n"+"\r\n"], { type: "plain/text;charset=utf-8" });
      saveAs(file, this.imrdetail.case_number +'.txt');
    } else {
      var blob = new Blob([$(".info").html()], {type: "text/plain;charset=utf-8"});
      saveAs(blob, this.tags+"_"+this.imrdetail.case_number+".html");
    }
    
  }

  copy_text(){
    var range:any = document.createRange();
    range.selectNode(document.getElementById("info"));
    window.getSelection().removeAllRanges(); // clear current selection
    window.getSelection().addRange(range); // to select text
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
    this.msg_view("Copy Text");
    // var val:any = "Case Number: "+this.imrdetail.case_number+"\r\n"+"\r\n"+
    //   "==================================="+"\r\n"+
    //   "Clinical Summary : "+"\r\n"+"==================================="+"\r\n"+this.imrdetail.clinical_simmary+"\r\n"+"\r\n"+
    //   "IMR Final : "+"\r\n"+"==================================="+"\r\n"+this.imrdetail.how_imr_final_determ+"\r\n"+"\r\n"+
    //   "IMR Decision Explanation : "+"\r\n"+"==================================="+"\r\n"+this.imrdetail.imr_decision_explan+"\r\n"+"\r\n"+
    //   "IMR Decision Summary : "+"\r\n"+"==================================="+"\r\n"+this.imrdetail.imr_decision_summary+"\r\n"+"\r\n";
    // let selBox = document.createElement('textarea');
    // selBox.style.position = 'fixed';
    // selBox.style.left = '0';
    // selBox.style.top = '0';
    // selBox.style.opacity = '0';
    // selBox.value = val;
    // document.body.appendChild(selBox);
    // selBox.focus();
    // selBox.select();
    // document.execCommand('copy');
    // document.body.removeChild(selBox);
  }


  download_Summary_Report(id){
    console.log(id);
    console.log(this.summary_keys);
console.log("Asd");

    let text='';

    for (let index = 0; index < this.summary_keys.length; index++) {
      text = text + this.summary_keys[index] + " : " + "===================================" +'\n' + this.clinical_summary[this.summary_keys[index]] + '\n \n';
    }
    console.log(text);
    
    
    if(id === 'summary'){
      let file = new Blob(["CLINICAL SUMMARY:" +"\r\n"+ text], { type: "plain/text;charset=utf-8" });
      saveAs(file, 'CLINICAL_SUMMARY.txt');
    } 
    else {
      let file = new Blob(["CLINICAL SUMMARY REPORT:" +"\r\n"+ text +"\r\n"
      +"\r\n"+'Causes: '+"===================================" + "\r\n" + this.CausesArray+
      "\r\n"+'Symptoms: '+"===================================" + "\r\n" + this.SymptomsArray+
      "\r\n"+'Diseases: '+"===================================" + "\r\n" + this.DiseasesArray+
      "\r\n"+'Drugs: '+"===================================" + "\r\n" + this.DrugsArray], { type: "plain/text;charset=utf-8" });
      saveAs(file, 'CLINICAL_SUMMARY_REPORT.txt');
    }
  }


  save(){
    this.msg_view('Work In-Progress');
  }
}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_user/medicolegal/medicolegal.component.ts